"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommodityExclusionsFromIds = exports.getCommodityExclusionFromId = exports.getCommodityIdFromHSCodes = exports.getCommodityFromHSCodes = exports.getCommodityIdFromHSCode = exports.getCommodityFromHSCode = exports.normalizeHSCodes = exports.normalizeHSCode = exports.getCommodityExclusionIdsForCommodityIds = exports.getCommodityExclusionIdsForCategory = exports.commodityIdsForCategory = exports.getCommoditiesForCategory = exports.getTempSensitiveFromId = exports.getNewUsedApplicableFromId = exports.getCommodityIdFromName = exports.getCommodityNameFromId = exports.getCommodityFromId = exports.getCommodityItems = exports.getCommodities = exports.allCommoditiesV2 = exports.allCommodities = exports.allCommodityExclusions = exports.eCommodityCategory = void 0;
const utils_1 = require("@loadsure/utils");
const commodity_1 = __importDefault(require("./commodity"));
const commodityExclusion_1 = __importDefault(require("./commodityExclusion"));
const commodities_json_1 = __importDefault(require("./commodities.json"));
const commoditiesV2_json_1 = __importDefault(require("./commoditiesV2.json"));
const commodity_exclusions_json_1 = __importDefault(require("./commodity-exclusions.json"));
var eCommodityCategory;
(function (eCommodityCategory) {
    eCommodityCategory["ALL"] = "ALL";
    eCommodityCategory["GENERAL_MERCHANDISE"] = "GENERAL_MERCHANDISE";
    eCommodityCategory["REFRIGERATED_GOODS"] = "REFRIGERATED_GOODS";
    eCommodityCategory["EXCLUDED"] = "EXCLUDED";
})(eCommodityCategory = exports.eCommodityCategory || (exports.eCommodityCategory = {}));
let commodityExclusions;
const allCommodityExclusions = () => {
    if (!commodityExclusions) {
        commodityExclusions = commodity_exclusions_json_1.default
            .map(commodityExclusion_1.default.fromObj)
            .sort((a, b) => a.sortOrder - b.sortOrder);
    }
    return commodityExclusions;
};
exports.allCommodityExclusions = allCommodityExclusions;
let commodities;
const allCommodities = (version = 2) => {
    if (version === 1) {
        commodities = commodities_json_1.default
            .map(commodity_1.default.fromObj)
            .sort((a, b) => a.sortOrder - b.sortOrder);
    }
    else {
        commodities = commoditiesV2_json_1.default
            .map(commodity_1.default.fromObj)
            .sort((a, b) => a.sortOrder - b.sortOrder);
    }
    return commodities;
};
exports.allCommodities = allCommodities;
const allCommoditiesV2 = () => {
    commodities = commoditiesV2_json_1.default
        .map(commodity_1.default.fromObj)
        .sort((a, b) => a.sortOrder - b.sortOrder);
    return commodities;
};
exports.allCommoditiesV2 = allCommoditiesV2;
const getCommodities = (commodityIds, version = 2) => {
    return exports.allCommodities(version).filter((commodity) => {
        if (commodityIds) {
            return commodityIds.includes(commodity.id);
        }
        return commodity.category !== eCommodityCategory.EXCLUDED;
    });
};
exports.getCommodities = getCommodities;
const getCommodityItems = (commodityIds) => exports.getCommodities(commodityIds).map((commodity) => new utils_1.Item(commodity.id, commodity.name));
exports.getCommodityItems = getCommodityItems;
const getCommodityFromId = (id, version = 2) => exports.allCommodities(version).find((commodity) => commodity.id === id);
exports.getCommodityFromId = getCommodityFromId;
const getCommodityNameFromId = (id) => { var _a; return (_a = exports.getCommodityFromId(id)) === null || _a === void 0 ? void 0 : _a.name; };
exports.getCommodityNameFromId = getCommodityNameFromId;
const getCommodityIdFromName = (name) => { var _a; return (_a = exports.allCommodities().find((commodity) => commodity.name === name)) === null || _a === void 0 ? void 0 : _a.id; };
exports.getCommodityIdFromName = getCommodityIdFromName;
const getNewUsedApplicableFromId = (id) => { var _a; return (_a = exports.getCommodityFromId(id)) === null || _a === void 0 ? void 0 : _a.newUsedApplicable; };
exports.getNewUsedApplicableFromId = getNewUsedApplicableFromId;
const getTempSensitiveFromId = (id) => { var _a; return (_a = exports.getCommodityFromId(id)) === null || _a === void 0 ? void 0 : _a.tempSensitive; };
exports.getTempSensitiveFromId = getTempSensitiveFromId;
const getCommoditiesForCategory = (category) => exports.allCommodities().filter((commodity) => commodity.category === category);
exports.getCommoditiesForCategory = getCommoditiesForCategory;
const commodityIdsForCategory = (category) => exports.getCommoditiesForCategory(category).map((commodity) => commodity.id);
exports.commodityIdsForCategory = commodityIdsForCategory;
const getCommodityExclusionIdsFromCommodities = (commoditiesList, worldwide) => Array.from(new Set(commoditiesList
    .map((commodity) => worldwide ? commodity.worldwideExclusions : commodity.usaExclusions)
    .flat()));
const getCommodityExclusionIdsForCategory = (category, worldwide) => getCommodityExclusionIdsFromCommodities(exports.getCommoditiesForCategory(category), worldwide);
exports.getCommodityExclusionIdsForCategory = getCommodityExclusionIdsForCategory;
const getCommodityExclusionIdsForCommodityIds = (commodityIds, worldwide = false, version = 2) => getCommodityExclusionIdsFromCommodities(exports.getCommodities(commodityIds, version), worldwide);
exports.getCommodityExclusionIdsForCommodityIds = getCommodityExclusionIdsForCommodityIds;
const normalizeHSCode = (hsCodeStr) => {
    const parts = hsCodeStr.split(".");
    const hsCode = parts
        .map((part, index) => {
        if (index === 0) {
            if (part.length >= 6) {
                return part;
            }
            if (part.length > 4) {
                return utils_1.zeroPad(part, 6);
            }
            return utils_1.zeroPad(part, 4);
        }
        return part;
    })
        .join("");
    return hsCode;
};
exports.normalizeHSCode = normalizeHSCode;
const normalizeHSCodes = (hsCodeStrs) => hsCodeStrs.map(exports.normalizeHSCode);
exports.normalizeHSCodes = normalizeHSCodes;
const getCommodityFromHSCode = (hsCode) => {
    const normalizedHSCode = exports.normalizeHSCode(hsCode);
    const match = exports.allCommodities()
        .map((commodity) => {
        const matchHSCode = commodity.hsCodes.find((aHSCode) => normalizedHSCode.startsWith(aHSCode));
        if (matchHSCode) {
            return [commodity, matchHSCode.length];
        }
        return undefined;
    })
        .reduce((longestMatch, aMatch) => {
        var _a, _b;
        if (((_a = aMatch === null || aMatch === void 0 ? void 0 : aMatch[1]) !== null && _a !== void 0 ? _a : 0) > ((_b = longestMatch === null || longestMatch === void 0 ? void 0 : longestMatch[1]) !== null && _b !== void 0 ? _b : 0)) {
            return aMatch;
        }
        return longestMatch;
    });
    return match === null || match === void 0 ? void 0 : match[0];
};
exports.getCommodityFromHSCode = getCommodityFromHSCode;
const getCommodityIdFromHSCode = (hsCode) => { var _a; return (_a = exports.getCommodityFromHSCode(hsCode)) === null || _a === void 0 ? void 0 : _a.id; };
exports.getCommodityIdFromHSCode = getCommodityIdFromHSCode;
const getCommodityFromHSCodes = (hsCodes) => {
    if (hsCodes === null || hsCodes === void 0 ? void 0 : hsCodes.length) {
        const hsCodeCommodities = hsCodes.map(exports.getCommodityFromHSCode);
        let commodity = hsCodeCommodities.find((hsCodeCommodity) => (hsCodeCommodity === null || hsCodeCommodity === void 0 ? void 0 : hsCodeCommodity.category) === eCommodityCategory.REFRIGERATED_GOODS);
        if (!commodity) {
            [commodity] = hsCodeCommodities;
        }
        return commodity;
    }
    return undefined;
};
exports.getCommodityFromHSCodes = getCommodityFromHSCodes;
const getCommodityIdFromHSCodes = (hsCodes) => { var _a; return (_a = exports.getCommodityFromHSCodes(hsCodes)) === null || _a === void 0 ? void 0 : _a.id; };
exports.getCommodityIdFromHSCodes = getCommodityIdFromHSCodes;
const getCommodityExclusionFromId = (id) => {
    const commodityExclusion = exports.allCommodityExclusions().find((aCommodityExclusion) => aCommodityExclusion.id === id);
    if (commodityExclusion) {
        return commodityExclusion;
    }
    throw Error(`Cannot determine commodity exclusion with id ${id}`);
};
exports.getCommodityExclusionFromId = getCommodityExclusionFromId;
const getCommodityExclusionsFromIds = (ids) => ids === null || ids === void 0 ? void 0 : ids.map((commodityExclusion) => exports.getCommodityExclusionFromId(commodityExclusion)).sort((a, b) => a.sortOrder - b.sortOrder);
exports.getCommodityExclusionsFromIds = getCommodityExclusionsFromIds;
//# sourceMappingURL=index.js.map